import { parseGlbBinary } from './parseGlbBinary';
import { parseWithGltfLoader } from './parseWithGltfLoader';
import type { GlbValidationReport } from './types';
import {
  validateCameraAnimation,
  validateGlbAnalysis,
  validateRequiredExtensions,
  validateSceneTopology,
  validateSelectedFile,
  validateUsedExtensions,
} from './validateGlbAnalysis';

export type {
  GlbAnalysisIssue,
  GlbAnalysisStage,
  GlbMaterialFinding,
  GlbAnalysisSummary,
  GlbValidationReport,
  ParsedGlbBinary,
  ParsedGlbImage,
  ParsedGlbMaterial,
  ParsedGlbTexture,
  ParsedRuntimeGlb,
} from './types';

export {
  validateCameraAnimation,
  validateRequiredExtensions,
  validateSceneTopology,
  validateSelectedFile,
  validateUsedExtensions,
};

export async function analyzeUploadedGlb(
  file: File,
  options: {
    useWorker?: boolean;
    onProgress?: (value: number, label: string) => void;
  } = {},
): Promise<GlbValidationReport> {
  const { onProgress } = options;

  validateSelectedFile(file);

  onProgress?.(10, 'Reading file');
  const arrayBuffer = await file.arrayBuffer();

  onProgress?.(30, 'Validating binary');
  const binary = parseGlbBinary(arrayBuffer);

  onProgress?.(60, 'Parsing scene');
  const runtime = await parseWithGltfLoader(arrayBuffer);

  onProgress?.(85, 'Applying pipeline rules');
  const report = validateGlbAnalysis({
    file,
    binary,
    runtime,
  });

  onProgress?.(100, 'Validation complete');
  return report;
}
